import type { FlightLayover, FlightSegment } from '../types';

/** e.g. "3h 50min" — matches view-ticket / email copy */
export function formatLayoverDuration(mins?: number | null): string {
  if (mins == null || !Number.isFinite(mins) || mins <= 0) return '';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h <= 0) return `${m}min`;
  if (m <= 0) return `${h}h`;
  return `${h}h ${m}min`;
}

export function formatLayoverLabel(layover: FlightLayover): string {
  const dur = formatLayoverDuration(layover.duration);
  const place = layover.name?.trim() || layover.id?.trim() || 'connection';
  const overnight = layover.overnight ? ' (overnight)' : '';
  return dur ? `${dur} layover in ${place}${overnight}` : `Layover in ${place}${overnight}`;
}

/** Per-segment meal line (view-ticket style). Uses stored value or class/duration heuristic. */
export function segmentMealLabel(seg: FlightSegment): string | null {
  const explicit = seg.mealOptions?.trim();
  if (explicit) return explicit;

  const cls = (seg.travelClass || '').toLowerCase();
  const mins = seg.duration ?? 0;

  if (cls.includes('first')) return 'Hot meal';
  if (cls.includes('business')) return 'Hot meal';
  if (cls.includes('premium')) return 'Meal';
  if (mins >= 240) return 'Meal';
  if (mins >= 150) return 'Meal / refreshment';
  if (mins >= 90) return 'Snack';

  return null;
}
